import { __ } from "@wordpress/i18n";

export const CONTENT_POSITION_OPTIONS = [
	{
		label: __("Top Left", "magazine-blocks"),
		value: "top-left",
	},
	{
		label: __("Top Center", "magazine-blocks"),
		value: "top-center",
	},
	{
		label: __("Top Right", "magazine-blocks"),
		value: "top-right",
	},
	{
		label: __("Center Left", "magazine-blocks"),
		value: "center-left",
	},
	{
		label: __("Center Center", "magazine-blocks"),
		value: "center-center",
	},
	{
		label: __("Center Right", "magazine-blocks"),
		value: "center-right",
	},
	{
		label: __("Bottom Left", "magazine-blocks"),
		value: "bottom-left",
	},
	{
		label: __("Bottom Center", "magazine-blocks"),
		value: "bottom-center",
	},
	{
		label: __("Bottom Right", "magazine-blocks"),
		value: "bottom-right",
	},
];

export const MASK_SHAPE = [
	{ label: __("None", "magazine-blocks"), value: "none" },
	{ label: __("Circle", "magazine-blocks"), value: "circle" },
	{ label: __("Diamond", "magazine-blocks"), value: "diamond" },
	{ label: __("Hexagon", "magazine-blocks"), value: "hexagon" },
	{ label: __("Rounded", "magazine-blocks"), value: "rounded" },
	{ label: __("Blob 1", "magazine-blocks"), value: "blob1" },
	{ label: __("Blob 2", "magazine-blocks"), value: "blob2" },
	{ label: __("Blob 3", "magazine-blocks"), value: "blob3" },
	{ label: __("Blob 4", "magazine-blocks"), value: "blob4" },
];

export const MASK_SIZE = [
	{ label: __("Auto", "magazine-blocks"), value: "auto" },
	{ label: __("Contain", "magazine-blocks"), value: "contain" },
	{ label: __("Cover", "magazine-blocks"), value: "cover" },
];

export const MASK_POSITION = [
	{ label: __("Center Top", "magazine-blocks"), value: "center-top" },
	{ label: __("Center Center", "magazine-blocks"), value: "center-center" },
	{ label: __("Center Bottom", "magazine-blocks"), value: "center-bottom" },
	{ label: __("Left Top", "magazine-blocks"), value: "left-top" },
	{ label: __("Left Center", "magazine-blocks"), value: "left-center" },
	{ label: __("Left Bottom", "magazine-blocks"), value: "left-bottom" },
	{ label: __("Right Top", "magazine-blocks"), value: "right-top" },
	{ label: __("Right Center", "magazine-blocks"), value: "right-center" },
	{ label: __("Right Bottom", "magazine-blocks"), value: "right-bottom" },
];

export const MASK_REPEAT = [
	{ label: __("No Repeat", "magazine-blocks"), value: "no-repeat" },
	{ label: __("Repeat", "magazine-blocks"), value: "repeat" },
	{ label: __("Repeat-X", "magazine-blocks"), value: "repeat-x" },
	{ label: __("Repeat-Y", "magazine-blocks"), value: "repeat-y" },
];

export const SEPARATOR_POSITION_OPTIONS = [
	{ label: __("Before Title", "magazine-blocks"), value: "before-title" },
	{ label: __("After Title", "magazine-blocks"), value: "after-title" },
	{
		label: __("After Sub Title", "magazine-blocks"),
		value: "after-sub-title",
	},
];

export const SEPARATOR_STYLE_OPTIONS = [
	{ label: __("None", "magazine-blocks"), value: "none" },
	{ label: __("Solid", "magazine-blocks"), value: "solid" },
	{ label: __("Dashed", "magazine-blocks"), value: "dashed" },
	{ label: __("Dotted", "magazine-blocks"), value: "dotted" },
	{ label: __("Double", "magazine-blocks"), value: "double" },
	{ label: __("Groove", "magazine-blocks"), value: "groove" },
	{ label: __("Inset", "magazine-blocks"), value: "inset" },
	{ label: __("Outset", "magazine-blocks"), value: "outset" },
	{ label: __("Ridge", "magazine-blocks"), value: "ridge" },
];

export const OBJECT_FIT_OPTIONS = [
	{
		label: __("Fill", "magazine-blocks"),
		value: "fill",
	},
	{
		label: __("Cover", "magazine-blocks"),
		value: "cover",
	},
	{
		label: __("Contain", "magazine-blocks"),
		value: "contain",
	},
	{
		label: __("None", "magazine-blocks"),
		value: "none",
	},
	{
		label: __("Scale Down", "magazine-blocks"),
		value: "scale-down",
	},
];

export const HOVER_IMAGE_OPTIONS = [
	{
		label: __("None", "magazine-blocks"),
		value: "none",
	},
	{
		label: __("Static", "magazine-blocks"),
		value: "static",
	},
	{
		label: __("Zoom In", "magazine-blocks"),
		value: "zoom-in",
	},
	{
		label: __("Slide", "magazine-blocks"),
		value: "slide",
	},
	{
		label: __("Gray Scale", "magazine-blocks"),
		value: "gray-scale",
	},
	{
		label: __("Blur", "magazine-blocks"),
		value: "blur",
	},
];

export const IMAGE_FILTER_OPTIONS = [
	{
		label: __("None", "magazine-blocks"),
		value: "none",
	},
	{
		label: __("Grayscale", "magazine-blocks"),
		value: "gray-scale",
	},
	{
		label: __("Sepia", "magazine-blocks"),
		value: "sepia",
	},
	{
		label: __("Saturation", "magazine-blocks"),
		value: "saturation",
	},
	{
		label: __("Vintage", "magazine-blocks"),
		value: "vintage",
	},
	{
		label: __("Earlybird", "magazine-blocks"),
		value: "early-bird",
	},
	{
		label: __("Toaster", "magazine-blocks"),
		value: "toaster",
	},
	{
		label: __("Mayfair", "magazine-blocks"),
		value: "mayfair",
	},
];
